import salesforce from '../images/salesforce.png';
import oracle from '../images/oracle.png';
import sql from '../images/sql.png';
import hubspot from '../images/hubspot.png';
import github from '../images/github.png';

export const CONNECTOR_THEMES = {
  salesforce: {
    label: 'Salesforce',
    logo: salesforce,
    gradient: 'linear-gradient(90deg, #0767C3 0%, #00A1E0 100%)',
  },
  oracle: {
    label: 'Oracle',
    logo: oracle,
    gradient: 'linear-gradient(90deg, #FF4233 0%, #B31217 100%)',
  },
  sql: {
    label: 'SQL',
    logo: sql,
    gradient: 'linear-gradient(90deg, #35A854 0%, #22543D 100%)',
  },
  hubspot: {
    label: 'HubSpot',
    logo: hubspot,
    gradient: 'linear-gradient(90deg, #fd8c03ff 0%, #e0d100ff 100%)',
  },
  github: {
    label: 'GitHub',
    logo: github,
    gradient: 'linear-gradient(90deg, #24292e 0%, #586069 100%)',
  },
//   snowflake: {
//     label: 'Snowflake',
//     logo: require('../images/snowflake.png'),
//     background: 'linear-gradient(90deg, #4AC6F2, #72D4EB)',
//   },
//   postgres: {
//     label: 'PostgreSQL',
//     logo: require('../images/postgres.png'),
//     background: 'linear-gradient(90deg, #336791, #2F5C84)',
//   },
//   mongodb: {
//     label: 'MongoDB',
//     logo: require('../images/mongodb.png'),
//     background: 'linear-gradient(90deg, #13aa52, #116149)',
//   },
//   aws: {
//     label: 'AWS',
//     logo: require('../images/aws.png'),
//     background: 'linear-gradient(90deg, #FF9900, #232F3E)',
//   },
  default: {
    label: 'Connector',
    logo: null,
    gradient: 'linear-gradient(90deg, #0154D2 0%, #02296C 100%)',
  },
};
